import { Box, HStack, Image, Link, Stack } from "@chakra-ui/react"
import { Text } from "@/components"
import { Resource } from "@/types"

interface Props {
  resource: Resource
}

export const ResourceListItem = ({ resource }: Props) => {
  return (
    <HStack
      cursor="pointer"
      bg="white"
      borderRadius={10}
      boxShadow="sm"
      _hover={{ boxShadow: "lg" }}
      overflow="hidden"
      onClick={() => window.open(resource.url, "_blank", "noopener,noreferrer")}
    >
      <Box w="20%" h="100%">
        <Image
          h="100%"
          w="100%"
          objectFit="cover"
          src={resource.photo ?? "https://images.unsplash.com/photo-1432821596592-e2c18b78144f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8YmxvZ3xlbnwwfHwwfHw%3D&w=1000&q=80"}
        />
      </Box>
      <Stack p={5} w="80%" gap={5}>
        <Text fontSize="2xl" fontWeight="bold">
          { resource.title }
        </Text>
        {
          resource.excerpt && (
            <Text fontSize="sm" color="gray.500" lineClamp="3">
              {resource.excerpt}
            </Text>
          )
        }
        <Text as={Link} fontSize="md" color="black" fontWeight="bold" lineClamp="2">
          Read More
        </Text>
      </Stack>
    </HStack>
  )
}
